export default function (store, { dragItemsCoords, dropAreasCoords }) {
    store.setState({ dragItemsCoords, dropAreasCoords });
}
//# sourceMappingURL=before.js.map